import { UserDetailResponse } from '@/generated'
import { IUserDetails } from './user-details-interface'

export const userDetailsDTO = (
  userDetails: UserDetailResponse
): IUserDetails => {
  return {
    firstName: userDetails.firstname,
    lastName: userDetails.lastname,
    email: userDetails.email,
    status: userDetails.activation,
    role: userDetails.useraccesslevel,
    joinedDate: userDetails.joined_date,
    lastLogin: userDetails.last_login_date,
    invitationValid: userDetails.invitation_valid,
  }
}
